import { useEffect, useMemo, useState } from 'react';
import { getContestsGroupedByCategory, type ContestCategoryGroup } from '@utils/contestCatalog';
import { loadMergedSportContestCatalog } from '@utils/contestCatalogApi';
import { uniqueCatalogContests } from '@utils/contestSelfEvaluation';

/** Foundation contest groups from DB catalog (falls back to seed when DB is empty). */
export function useFoundationCatalogGroups(sportName: string, refreshKey = 0) {
  const [categoryGroups, setCategoryGroups] = useState<ContestCategoryGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [fromDb, setFromDb] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    void loadMergedSportContestCatalog(sportName).then(({ catalog, fromDb: dbSource }) => {
      if (cancelled) return;
      if (catalog) {
        setCategoryGroups(getContestsGroupedByCategory(catalog, 'foundation'));
        setFromDb(dbSource);
      } else {
        setCategoryGroups([]);
        setFromDb(false);
      }
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [sportName, refreshKey]);

  const allContests = useMemo(
    () => uniqueCatalogContests(categoryGroups.flatMap((g) => g.contests)),
    [categoryGroups],
  );
  const hasContests = allContests.length > 0;

  return { categoryGroups, allContests, loading, fromDb, hasContests };
}
